import React, { useEffect } from 'react';
import { MenuDish } from '../constants/type.constant';
import swiper from "swiper";
import _ from 'lodash';
import FoodDetailInfo from './food-detail-info.component';
import { isIphonex } from '../tools/utils';
import { useSnackbar } from 'notistack';

// 加入或移出购物车
enum UPGRADE {
    REMOVE_DISH = -1,
    ADD_DISH = 1,
}

const FoodDetail = ({
    menuDish,
    liteMode,
    updateValue,
    changeMenuQuantity,
    customer,
    openSetDishDetail,
    initialSlide,
}: Props) => {
    // 手机型号判断
    const _isIphonex = isIphonex();
    const { closeSnackbar } = useSnackbar();

    useEffect(() => {
        closeSnackbar();
        // 初始化菜品大图轮播图
        new swiper('#menuDetail .swiper-container', {
            //当改变Swiper的样式（例如隐藏/显示）或者修改swiper的子元素时，自动初始化swiper
            observer: true,
            //当Swiper的父元素变化时，例如window.resize，Swiper更新
            observeParents: true,
            //设定初始化时slide的索引
            initialSlide: initialSlide,
        })
    }, [])

    return (
        <div className="menuDetail" id="menuDetail">
            <div className="swiper-container">
                <div className="swiper-wrapper">
                    {
                        menuDish.map((item, index) => (
                            <FoodDetailInfo
                                liteMode={liteMode}
                                updateValue={updateValue}
                                changeMenuQuantity={changeMenuQuantity}
                                key={index}
                                item={item}
                                customer={customer}
                                isIphonex={_isIphonex}
                                openSetDishDetail={() => openSetDishDetail?.(item)}
                            />
                        ))
                    }
                </div>
            </div>
        </div >
    )
}

export default FoodDetail;

// 菜品大图组件
// class FoodDetail2 extends React.Component<Props, State>{
//     public isDescriptHeight: boolean = false;
//     public detailBottomRef: HTMLDivElement | null = null;
//     public BOTTOM_HEIGHT: number = 1;
//     // 手机型号判断
//     public isIphonex = isIphonex();
//     constructor(props: Props) {
//         super(props);
//         this.state = {
//             // 是否打开菜品详细信息
//             isOpenDescript: false,
//             // 卡片大图详情底部区域高度
//             bottomHeight: 0
//         }
//     }
//     // *********************
//     // 生命周期
//     // *********************
//     public UNSAFE_componentWillMount() {
//         const findRes = this.getSettingInfoValue('show-item-name1-or-item-name2')
//         if (findRes) this.isShowName1 = findRes.value.showItemName1
//     }
//     public componentDidMount() {
//         // 初始化菜品大图轮播图
//         new swiper('#menuDetail .swiper-container', {
//             //当改变Swiper的样式（例如隐藏/显示）或者修改swiper的子元素时，自动初始化swiper
//             observer: true,
//             //当Swiper的父元素变化时，例如window.resize，Swiper更新
//             observeParents: true,
//             //设定初始化时slide的索引
//             initialSlide: this.props.initialSlide,
//         })
//     }

//     public async componentWillUnmount() {
//         // $ alwyas unsubscribe in un mount function
//     }

//     // *********************
//     // 方法区
//     // *********************
//     public isShowName1 = true;
//     public getSettingInfoValue(str: string) {
//         const SETTING = StateManager.getFromCache('settingInfo');
//         return _.find(SETTING, ['name', str]);
//     }

//     /**
//      * 查看菜品详细文本信息
//      */
//     public openDescript() {

//     }

//     // 关闭菜品大图
//     closeMenuDetail = () => {
//         this.props.updateValue({
//             foodDetailVisible: false
//         })
//     }

//     public countHeight() {
//         if (this.detailBottomRef) {
//             this.BOTTOM_HEIGHT = _.get(this.detailBottomRef, 'offsetHeight', 0)
//             return `calc(100% - ${this.BOTTOM_HEIGHT}px)`;
//         }
//         return `calc(100% - ${this.BOTTOM_HEIGHT}px)`;
//     }

//     // *********************
//     // 视图区
//     // *********************
//     public render() {
//         const { menuDish, customer } = this.props;
//         return (
//             <div className="menuDetail" id="menuDetail">
//                 <div className="swiper-container">
//                     <div className="swiper-wrapper">
//                         {
//                             menuDish.map((item, index) => (
//                                 <FoodDetailInfo
//                                     liteMode={this.props.liteMode}
//                                     updateValue={this.props.updateValue}
//                                     changeMenuQuantity={this.props.changeMenuQuantity}
//                                     key={index}
//                                     item={item}
//                                     customer={customer}
//                                     isIphonex={this.isIphonex}
//                                     openSetDishDetail={() => this.props?.openSetDishDetail?.(item)}
//                                 />
//                             ))
//                         }
//                     </div>
//                 </div>
//             </div >
//         )
//     }

// }
type Props = {
    // 选中的二级菜单的菜品
    menuDish: Array<MenuDish & { history_num?: number }>
    // 轮播图索引
    initialSlide: number
    /**
     * 更新购物车
     * @param dish 菜品数据`Dish`
     * @param type 操作类型` UPGRADE_OPERATES`
     */
    changeMenuQuantity(dish: MenuDish, type: UPGRADE, expandDish?: MenuDish): void
    // 更新状态
    updateValue(val: any): void
    customer: string
    // 精简版模式
    liteMode?: boolean;
    // 打开套餐
    openSetDishDetail?(item: MenuDish): void
}

type State = {
    isOpenDescript: boolean;
    // 卡片大图详情底部区域高度
    bottomHeight: number;
}